import React from 'react';

const statusIcons = {
  'hub-scan': require('../../../../icons/shipment-status/hub-scan.svg').default,
  'info-general': require('../../../../icons/shipment-status/info-general.svg').default,
  'carrier-change': require('../../../../icons/shipment-status/carrier-change.svg').default,
  'carrier-contact': require('../../../../icons/shipment-status/carrier-contact.svg').default,
  'delay': require('../../../../icons/shipment-status/delay.svg').default,
  'delivery-success': require('../../../../icons/shipment-status/delivery-success.svg').default,
  'delivery-drop-off': require('../../../../icons/shipment-status/delivery-drop-off.svg').default,
  'delivery-pickup-point': require('../../../../icons/shipment-status/delivery-pickup-point.svg').default,
  'delivery-third-party': require('../../../../icons/shipment-status/delivery-third-party.svg').default,
  'delivery-address-changed': require('../../../../icons/shipment-status/delivery-address-changed.svg').default,
  'date': require('../../../../icons/shipment-status/date.svg').default,
  'delivery-failed': require('../../../../icons/shipment-status/delivery-failed.svg').default,
  'tracking-alert': require('../../../../icons/shipment-status/tracking-alert.svg').default,
  'delivery-completed': require('../../../../icons/shipment-status/delivery-completed.svg').default,
  'address-good': require('../../../../icons/shipment-status/address-good.svg').default,
  'problem': require('../../../../icons/shipment-status/problem.svg').default,
  'delivery-international': require('../../../../icons/shipment-status/delivery-international.svg').default,
  'delivery-active': require('../../../../icons/shipment-status/delivery-active.svg').default,
  'return-postal': require('../../../../icons/shipment-status/return-postal.svg').default,
  'shipment-return': require('../../../../icons/shipment-status/shipment-return.svg').default,
  'return-warehouse': require('../../../../icons/shipment-status/return-warehouse.svg').default,
  'new': require('../../../../icons/shipment-status/new.svg').default,
  'lost': require('../../../../icons/shipment-status/lost.svg').default,
  'delivery-update': require('../../../../icons/shipment-status/delivery-update.svg').default,
  'tracking-ok': require('../../../../icons/shipment-status/tracking-ok.svg').default,
  'warehouse-pickup': require('../../../../icons/shipment-status/warehouse-pickup.svg').default,
  'address-wrong': require('../../../../icons/shipment-status/address-wrong.svg').default,
  'transmission': require('../../../../icons/shipment-status/transmission.svg').default,
  'pickup': require('../../../../icons/shipment-status/pickup.svg').default,
  'hub-back': require('../../../../icons/shipment-status/hub-back.svg').default,
};

const ShipmentStatusIcon = ({ name, fill = 'white', size = 48 }) => {
  const Icon = statusIcons[name];
  return Icon ? <Icon style={{ fill, width: size, height: size }} /> : null;
};

export const getShipmentStatusIconsList = () => Object.keys(statusIcons);

export default ShipmentStatusIcon;